import styled from "styled-components";
import { FormWrapper, OrangeAccentCard } from "../../../styles/shared";

export const ProductNewWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
`;

export const PageHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 24px 0 0 0;
  margin-bottom: 32px;
  
  h1 {
    color: #ffffff;
    font-size: 32px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    i {
      color: #f29205;
      font-size: 36px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
    }
  }
`;

export const ProductCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px !important;
  
  @media (min-width: 768px) {
    padding: 32px !important;
  }
`;

export const CardTitle = styled.div`
  color: #f29205;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  
  @media (min-width: 768px) {
    font-size: 20px;
    margin-bottom: 24px;
    gap: 10px;
  }
  
  i {
    font-size: 22px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));
    
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 16px 0 16px;
  
  @media (min-width: 768px) {
    padding: 24px 24px 0 24px;
  }
  
  @media (min-width: 1200px) {
    padding: 24px 72px 0 72px;
  }
`;

export const PhotoSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const PhotoPreview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  border: 3px solid rgba(242, 146, 5, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
  flex-shrink: 0;
  
  &:hover {
    border-color: rgba(242, 146, 5, 0.6);
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(242, 146, 5, 0.3);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PhotoInfo = styled.div`
  flex: 1;
  min-width: 250px;
  
  .photo-label {
    color: #b0b0b0;
    font-size: 14px;
    margin-bottom: 12px;
    display: block;
  }
  
  .photo-selected {
    color: #00d4ff;
    font-size: 14px;
    margin-top: 12px;
    padding: 8px 12px;
    background: rgba(0, 212, 255, 0.1);
    border-radius: 8px;
    border: 1px solid rgba(0, 212, 255, 0.2);
    
    strong {
      color: #00d4ff;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
  gap: 12px;
  
  @media (min-width: 768px) {
    margin-top: 32px;
    padding-top: 24px;
    gap: 16px;
  }
  
  a {
    text-decoration: none;
  }
  
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
    
    > a {
      width: 100%;
      display: block;
    }
    
    .mobile-button,
    > a .mobile-button,
    > .mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 24px 0;
`;

export const VisuallyHiddenInput = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

export const StyledFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root {
        height: 48px !important;
        min-height: 48px !important;
        
        .MuiInputBase-input {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }
      
      .MuiInputLabel-root {
        font-size: 14px !important;
      }
      
      .MuiButton-root {
        height: 48px !important;
        min-height: 48px !important;
      }
    }
  }
`;

// Exportando FormWrapper compartilhado
export { FormWrapper };

